import {
    CHANNEL_GET_MY_DETAILS,
    CHANNEL_GET_MY_VIDEOS,
    CHANNEL_UPDATE_DETAILS,
    CHANNEL_ADD_VIDEO,
    CHANNEL_UPDATE_VIDEO,
    CHANNEL_DELETE_VIDEO,
    CHANNEL_GET_VIDEO_DETAILS,
    CHANNEL_GET_ALL,
    CHANNEL_GET_ALL_EVENTS,
    CHANNEL_SET_EVENT_AS_SPONSORED,
    CHANNEL_GET_ALL_VOTING_SESSIONS,
    CHANNEL_RECALCULATE_VOTING_TRANSACTIONS,
    CHANNEL_SET_ITEM_AS_SPONSORED,
    CHANNEL_GET_ALL_VIDEOS
} from "../actions/channel";

import {
    API_BASE_URL,
    CHANNEL_GET_MY_DETAILS_URL,
    CHANNEL_GET_MY_VIDEOS_URL,
    CHANNEL_UPDATE_DETAILS_URL,
    CHANNEL_ADD_VIDEO_URL,
    CHANNEL_UPDATE_VIDEO_URL,
    CHANNEL_DELETE_VIDEO_URL,
    CHANNEL_GET_VIDEO_DETAILS_URL,
    CHANNEL_GET_ALL_URL,
    CHANNEL_GET_ALL_EVENTS_URL,
    CHANNEL_SET_EVENT_AS_SPONSORED_URL,
    CHANNEL_GET_ALL_VOTING_SESSIONS_URL,
    CHANNEL_RECALCULATE_VOTING_TRANSACTIONS_URL,
    CHANNEL_SET_ITEM_AS_SPONSORED_URL,
    CHANNEL_GET_ALL_VIDEOS_URL
} from "../variables";

import axios from "axios";

const state = {};
const mutations = {};
const getters = {};
const actions = {
    [CHANNEL_GET_ALL_VIDEOS]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + CHANNEL_GET_ALL_VIDEOS_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [CHANNEL_GET_ALL_VOTING_SESSIONS]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + CHANNEL_GET_ALL_VOTING_SESSIONS_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [CHANNEL_RECALCULATE_VOTING_TRANSACTIONS]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + CHANNEL_RECALCULATE_VOTING_TRANSACTIONS_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [CHANNEL_SET_ITEM_AS_SPONSORED]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + CHANNEL_SET_ITEM_AS_SPONSORED_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [CHANNEL_GET_VIDEO_DETAILS]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + CHANNEL_GET_VIDEO_DETAILS_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [CHANNEL_GET_MY_DETAILS]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + CHANNEL_GET_MY_DETAILS_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [CHANNEL_GET_MY_VIDEOS]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + CHANNEL_GET_MY_VIDEOS_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [CHANNEL_UPDATE_DETAILS]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + CHANNEL_UPDATE_DETAILS_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [CHANNEL_ADD_VIDEO]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + CHANNEL_ADD_VIDEO_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [CHANNEL_UPDATE_VIDEO]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + CHANNEL_UPDATE_VIDEO_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [CHANNEL_DELETE_VIDEO]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + CHANNEL_DELETE_VIDEO_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },

    [CHANNEL_GET_ALL]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + CHANNEL_GET_ALL_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [CHANNEL_GET_ALL_EVENTS]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + CHANNEL_GET_ALL_EVENTS_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [CHANNEL_SET_EVENT_AS_SPONSORED]: ({ commit, state, getters }, payload) => {
        return axios({
            url: API_BASE_URL + CHANNEL_SET_EVENT_AS_SPONSORED_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
};


export default {
    mutations,
    actions,
    getters,
    state
};